module.exports = __webpack_public_path__ + "img/_costarica.9fe6434a.png";